import axios from '../../utils/axios';

export const FETCH_CUSTOM_SETTINGS_SUCCESS = 'FETCH_CUSTOM_SETTINGS_SUCCESS';
export const EDIT_CUSTOM_SETTINGS_SUCCESS = 'EDIT_CUSTOM_SETTINGS_SUCCESS';
export const ADD_CUSTOM_SETTINGS_SUCCESS = 'ADD_CUSTOM_SETTINGS_SUCCESS';

export const CUSTOM_SETTINGS_ERROR = 'CUSTOM_SETTINGS_ERROR';

const fetchCustomSettingsEndpoint = () =>
  `${process.env.REACT_APP_API_URL}custom-settings`;
const postCustomSettingsEndpoint = () =>
  `${process.env.REACT_APP_API_URL}custom-settings`;
const putCustomSettingsEndpoint = id =>
  `${process.env.REACT_APP_API_URL}custom-settings/${id}`;

export const fetchCustomSettingsSuccess = customSettings => dispatch =>
  dispatch({
    type: FETCH_CUSTOM_SETTINGS_SUCCESS,
    customSettings
  });

export const customSettingsError = error => dispatch =>
  dispatch({
    type: CUSTOM_SETTINGS_ERROR,
    error
  });

export const fetchCustomSettings = companyId => async dispatch => {
  try {
    const response = await axios.get(fetchCustomSettingsEndpoint(companyId));
    dispatch(fetchCustomSettingsSuccess(response.data.data));

    return response.data;
  } catch (error) {
    dispatch(customSettingsError(error));
  }
};

export const editCustomSettingsSuccess = customSettings => dispatch =>
  dispatch({
    type: EDIT_CUSTOM_SETTINGS_SUCCESS,
    customSettings
  });

export const editCustomSettings = (id, changes) => async dispatch => {
  const url = putCustomSettingsEndpoint(id);
  try {
    const response = await axios.put(url, changes);
    dispatch(editCustomSettingsSuccess(response.data));
  } catch (error) {
    dispatch(customSettingsError(error));
    throw new Error(error);
  }
};

export const addCustomSettingsSuccess = newCustomSettings => dispatch =>
  dispatch({
    type: ADD_CUSTOM_SETTINGS_SUCCESS,
    newCustomSettings
  });

export const addCustomSettings = (
  newCustomSettings,
  companyId
) => async dispatch => {
  try {
    await axios.post(postCustomSettingsEndpoint(), { ...newCustomSettings });

    dispatch(addCustomSettingsSuccess(newCustomSettings));
    dispatch(fetchCustomSettings(companyId));
  } catch (error) {
    dispatch(customSettingsError(error));
    throw new Error(error);
  }
};
